import { getLocationSettings } from "../../lib/location";
import type { AppUserAuthenticator } from "common/components/types";
import { checkExplicitSignOut } from "./session-storage";

export function getCredentials() {
    return getLocationSettings().googleCredentials;
}

function googleOAuth2CallbackURLForLocation(): string {
    return getLocationSettings().oAuthCallbackURL;
}

export function getHTTPGoogleOAuth2RedirectURL(state: string, authenticator: AppUserAuthenticator | undefined): URL {
    const creds = getCredentials();
    const redirectURL = new URL("https://accounts.google.com/o/oauth2/v2/auth");
    const { searchParams } = redirectURL;
    searchParams.append("scope", "email profile openid");
    searchParams.append("access_type", "offline");
    searchParams.append("include_granted_scopes", "false");
    searchParams.append("state", state);
    searchParams.append("redirect_uri", googleOAuth2CallbackURLForLocation());
    searchParams.append("response_type", "code");
    searchParams.append("client_id", creds.clientId);
    if (
        (authenticator?.failedSignIns ?? 0) > 0 ||
        (authenticator !== undefined && checkExplicitSignOut(authenticator?.appID))
    ) {
        // If we have failed a sign-in attempt from before, we need to force the select_account prompt,
        // because if we don't, we'll get stuck failing to sign in with the wrong account repeatedly.
        //
        // We also need to force the account selector if we have explicitly signed out.
        searchParams.append("prompt", "select_account consent");
    }
    return redirectURL;
}
